export default __webpack_public_path__ + "static/media/gitbook-white.649a5092.png";